import { useState } from "react";
import { useToast } from "../hooks/use-toast";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/maqvqwrb";

export default function FormspreeForm({ defaultMessage = "", topic = "Request Demo" }) {
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const { toast } = useToast();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const formData = new FormData(e.currentTarget);
    formData.append("_subject", `Fitest — ${topic}`);
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });
      if (!res.ok) throw new Error("Submission failed");
      setDone(true);
      toast({ title: "Submitted", description: "We'll be in touch within 1 business day." });
      e.currentTarget.reset();
    } catch (err) {
      toast({ title: "Error", description: err.message, variant: "destructive" });
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="glass rounded-2xl p-8 text-center" data-testid="formspree-success">
        <p className="text-2xl font-display mb-2">Thank you.</p>
        <p className="text-slate-400 text-sm">A member of the Fitest team will reach out shortly.</p>
        <Button className="btn-ghost-bordered rounded-full mt-6" onClick={() => setDone(false)} data-testid="form-send-another">
          Send another message
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4 glass rounded-2xl p-6 sm:p-8" data-testid="formspree-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="name" className="text-slate-300 text-xs uppercase tracking-widest">Name</Label>
          <Input id="name" name="name" required className="bg-white/5 border-white/10 mt-1" data-testid="form-name" />
        </div>
        <div>
          <Label htmlFor="company" className="text-slate-300 text-xs uppercase tracking-widest">Company</Label>
          <Input id="company" name="company" className="bg-white/5 border-white/10 mt-1" data-testid="form-company" />
        </div>
        <div>
          <Label htmlFor="email" className="text-slate-300 text-xs uppercase tracking-widest">Email</Label>
          <Input id="email" name="email" type="email" required className="bg-white/5 border-white/10 mt-1" data-testid="form-email" />
        </div>
        <div>
          <Label htmlFor="phone" className="text-slate-300 text-xs uppercase tracking-widest">Phone</Label>
          <Input id="phone" name="phone" className="bg-white/5 border-white/10 mt-1" data-testid="form-phone" />
        </div>
      </div>
      <div>
        <Label htmlFor="message" className="text-slate-300 text-xs uppercase tracking-widest">Message</Label>
        <Textarea
          id="message"
          name="message"
          required
          rows={5}
          defaultValue={defaultMessage}
          className="bg-white/5 border-white/10 mt-1"
          data-testid="form-message"
        />
      </div>
      <input type="hidden" name="topic" value={topic} />
      <Button type="submit" disabled={submitting} className="btn-glow w-full rounded-full h-12" data-testid="form-submit">
        {submitting ? "Sending…" : "Submit"}
      </Button>
    </form>
  );
}
